import { useContext, useState, useEffect } from "react";
import { AppContext } from "../App";
import { hospitalInfo } from "../content/hospitalContent";
import { FiChevronRight } from "react-icons/fi";
import { HiOutlineArrowNarrowRight, HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import career from "../assets/career.jpg";
import open1 from "../assets/open1.jpeg";
import open2 from "../assets/open2.jpeg";

import { IoMdArrowDropright } from "react-icons/io";

const sliderData = [
  //{ img: career, title: "", desc: "" },
  { img: open2, title: "", desc: "" },
  { img: open1, title: "", desc: "" },
  { img: banner1, title: "Modern Diagnostics", desc: "Advanced laboratory and imaging services." },
  { img: banner2, title: "Emergency Care", desc: "24/7 rapid response and trauma care." },
  { img: banner4, title: "In-Patient Comfort", desc: "Premium wards designed for your recovery." },
  { img: banner5, title: "Pharmacy Services", desc: "Fully stocked 24-hour clinical pharmacy." },
];

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [activeIdx, setActiveIdx] = useState(0);

  const handleNext = () => setActiveIdx((prev) => (prev + 1) % sliderData.length);
  const handlePrev = () => setActiveIdx((prev) => (prev - 1 + sliderData.length) % sliderData.length);

  // Autoplay Logic
  useEffect(() => {
    const timer = setInterval(handleNext, 5000);
    return () => clearInterval(timer);
  }, []);

  // Quick Links Map
  const quickLinks = [
    { label: "Clinical Services", target: "clinicalServices" },
    { label: "Our Foundations", target: "foundations" },
    { label: "Nanguba Care Program", target: "ncp" },
    { label: "Telehealth", target: "telehealth" }
  ];

  // --- BACKGROUND LOGIC ---
  // If the active index is 0 (Careers), fallback to banner1 for the background image.
  // Otherwise, use the image associated with the current active slide index.
  const currentBackgroundImage = activeIdx === 0 ? banner1 : sliderData[activeIdx].img;

  return (
    <>
      <section className="hero-viewport">
        {/* Updated background image source to use the conditional variable */}
        <img src={currentBackgroundImage} className="hero-bg-image" alt="Background" />
        <div className="hero-overlay" />

        <div className="hero-container">
          <div className="hero-glass-panel">
            <h1 className="hero-title">
              NANGUBA <span>HEALTH</span>
            </h1>

            {/* Interactive Links Container */}
            <ul className="hero-nav-list">
              {quickLinks.map((link, idx) => (
                <li
                  key={idx}
                  className="hero-nav-item"
                  onClick={() => appContext.navTo({ item: link.target })}
                >
                  {link.label}
                  <FiChevronRight className="hero-nav-icon" size={18} />
                </li>
              ))}
            </ul>

            <div className="hero-btns row g-2">
              <div className="col-12">
                <a href={hospitalInfo.scheduleUrl} target="_blank" rel="noreferrer" className="btn-light btn-modern">
                  Schedule an Appointment <HiOutlineArrowNarrowRight className="d-none d-md-inline-flex" size={22} /> <IoMdArrowDropright className="d-inline-flex d-md-none" size={22} />
                </a>
              </div>
              <div className="col-6">
                <a href={hospitalInfo.patientUrl} target="_blank" rel="noreferrer" className="btn-modern btn-teal">
                  Patient Portal
                </a>
              </div>
              <div className="col-6">
                <a href={hospitalInfo.staffUrl} target="_blank" rel="noreferrer" className="btn-modern btn-outline">
                  Staff Portal
                </a>
              </div>
            </div>
          </div>

          <div className="slider-section">
            <div className="stack-container">
              {sliderData.map((item, index) => {
                let cardClass = "card-hidden";
                const diff = (index - activeIdx + sliderData.length) % sliderData.length;

                if (diff === 0) cardClass = "card-active";
                else if (diff === 1) cardClass = "card-next";
                else if (diff === 2) cardClass = "card-last";

                return (
                  <div
                    key={index}
                    className={`stack-card ${cardClass}`}
                    onClick={() => setActiveIdx(index)}
                  >
                    <img src={item.img} alt={item.title} />
                    <div className="card-overlay">
                      <h4>{item.title}</h4>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Slider Arrows */}
            <div className="slider-arrows">
              <button className="arrow-btn" onClick={handlePrev} aria-label="Previous">
                <HiOutlineArrowLeft size={22} />
              </button>
              <button className="arrow-btn" onClick={handleNext} aria-label="Next">
                <HiOutlineArrowRight size={22} />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}